/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRichContactRequest } from './APIRichContactRequest';
import {
    APIRichContactRequestFromJSON,
    APIRichContactRequestFromJSONTyped,
    APIRichContactRequestToJSON,
} from './APIRichContactRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedContactGroupViewRequest
 */
export interface APIPatchedContactGroupViewRequest {
    /**
     * 
     * @type {Array<APIRichContactRequest>}
     * @memberof APIPatchedContactGroupViewRequest
     */
    contacts?: Array<APIRichContactRequest>;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedContactGroupViewRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedContactGroupViewRequest interface.
 */
export function instanceOfAPIPatchedContactGroupViewRequest(value: object): value is APIPatchedContactGroupViewRequest {
    return true;
}

export function APIPatchedContactGroupViewRequestFromJSON(json: any): APIPatchedContactGroupViewRequest {
    return APIPatchedContactGroupViewRequestFromJSONTyped(json, false);
}

export function APIPatchedContactGroupViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedContactGroupViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(APIRichContactRequestFromJSON)),
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedContactGroupViewRequestToJSON(value?: APIPatchedContactGroupViewRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(APIRichContactRequestToJSON)),
        'name': value['name'],
    };
}

